// extracted by mini-css-extract-plugin
export default {"wrapper":"ValidationWrapper_wrapper__cVDT+"};